var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip_message__body",attrs:{"data-testid":"vip-message"}},[_c('i',{staticClass:"rhg-font-icon--coffee-tea-facilities sm mr-3"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.vipLabel)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }